module.exports = __webpack_public_path__ + "static/media/load.fadf772d.gif";